export const setAffiliateFromUtmParams = () => {
  const params = new URLSearchParams(window.location.search);

  const medium = params.get("utm_medium");
  if (medium !== "affiliate") {
    return;
  }

  const source = params.get("utm_source");
  if (!source || source === "") {
    return;
  }

  setAffiliate(source);
};

export const setAffiliate = (affiliate: string) => {
  try {
    sessionStorage.setItem("affiliate", affiliate);
  } catch {
    // storage unavailable
  }
};

export const getAffiliate = (): string | null => {
  try {
    return sessionStorage.getItem("affiliate");
  } catch {
    return null;
  }
};
